"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ContactUs() {
  return <section id="contactus" className="py-32 relative overflow-hidden !bg-[rgba(93,1,78,1)]">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-screen-xl h-full pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-lg blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-accent/10 rounded-lg blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto">
          <div className="text-center">
            <h2 className="font-default font-semibold tracking-tight mb-4 text-secondary !text-5xl"><span className="!text-2xl"><span className="!text-4xl">Jetzt Probe- und Behandlungstermine buchen!</span></span></h2>
            
            <div className="mt-8 flex justify-center">
                <div className="zeeg-inline-widget w-full max-w-2xl" id="zeeg-embed-bodyconcept-by-linda-abnehmen-im-liegen" style={{
              minWidth: "320px",
              minHeight: "780px"
            }}></div>
                <script type="text/javascript" src="https://assets.zeeg.me/embed.min.js" data-user="bodyconcept-by-linda" data-event-type="abnehmen-im-liegen" data-redirect-parent="true" async></script>
            </div>
          </div>
        </div>
      </div>
    </section>;
}